import Paging from '@Components/MuiWrappers/Paging';
import ComplexBreadcrumb from '@Components/Shared/ComplexBreadcrumb';
import TranslationText from '@Components/Utilities/TranslationText';
import BlogArticleCategories from '@Components/Blog/BlogArticleCategories';
import BlogArticleTags from '@Components/Blog/BlogArticleTags';
import BlogArticleArchiveMenu from '@Components/Blog/BlogArticleArchiveMenu';
import ConditionalWrapper from '@Components/Utilities/ConditionalWrapper';
import { inquiryType } from '@Components/Utilities/SandhillsConstants';
import { useWindowSize } from '@Components/Utilities/WindowSize';
import translator from '@Components/Utilities/Translator';
import { loadable } from '@Components/Utilities/SandhillsLoadable';
const EmailModal = loadable(() => import('@Components/Shared/Modals/EmailModal'), true);
import { useState, useRef } from 'react';

const BlogListView = (props) => {
    const windowSize = useWindowSize();
    const [showEmailModal, setShowEmailModal] = useState(false);
    const [showShareButtons, setShowShareButtons] = useState(false);
    const [selectedInquiry, setSelectedInquiry] = useState('');
    const ref = useRef(null);
    const [samModel, setSamModel] = useState(props.SAMModel);

    const pageChange = (page) => {
        window.location.href = props.Paging.PagedURLTemplate + '/' + props.Paging.PageTranslation + '/' + page;
    };

    const onEmailModalToggle = () => {
        if (ref.current) {
            ref.current.focus();
        }
        setShowEmailModal(showEmailModal => !showEmailModal);
    };

    const openEmailModal = (inquiry, modalData) => {
        modalData = modalData || {};
        modalData.ModalTitle = translator.translate('sandhillssystem.share').toString();
        if (windowSize.isMobile && navigator.share) {
            navigator.share({
                title: document.title,
                url: window.location.href
            })
                .then(() => gtmPushEvent(gtmEventType.MobileShare))
                .catch(() => setShowShareButtons(true));
            return;
        } else {
            setShowShareButtons(true);
        }

        setSelectedInquiry(inquiry);
        setShowEmailModal(showEmailModal => !showEmailModal);
        setSamModel(previousState => {
            return {
                ...previousState,
                ...modalData
            };
        });
    };

    return (
        <div className='content-wrapper'>
            <div className={props.UseNewListPageDesign ? 'content-body list-redesign' : 'content-body'}>
                {props.IsAuthorBioPage && props.ShowEmailThis &&
                    <div className='article-content-wrapper'>
                        <button type='button' id='blog-detail-share' className='email-this' ref={ref} onClick={() => openEmailModal(inquiryType.EmailThis)}>
                            <i className='fas fa-share-alt media-buttons__icon' />
                            <span className='visually-hidden'><TranslationText key='email-button' tKey='sandhillssystem.share' /></span>
                        </button>
                    </div>}
                <ComplexBreadcrumb BreadCrumbModels={props.Breadcrumbs} LinkEndItem={true} />
                <div className='article-list-content-wrapper article-content-wrapper'>
                    {props.IsAuthorBioPage &&
                        <div className="blog-author">
                            <div className="blog-author-wrapper">
                                <div className="blog-author-img-wrapper">
                                    <img className="blog-author-img" src={props.AuthorProfileImageUrl} />
                                </div>
                                <div className="blog-author-bio-wrapper">
                                    <div className="blog-author-bio-heading"><strong>{props.AuthorBiographyTitle}</strong></div>
                                    <div dangerouslySetInnerHTML={{ __html: props.ArticleList[0].AuthorInfo.Biography }} />
                                </div>
                            </div>
                        </div>}
                    <div className='content-wrapper ts-flexbox'>
                        <h1 className={windowSize.isMobile ? 'page-title' : 'page-title pagename'}>{props.ArticleTitle}</h1>
                        {!props.IsAuthorBioPage &&
                            <a id='blog-rss-link' href={props.RSSUrl} aria-label='RSS XML data'><i className='fas fa-rss right rss link-bl' aria-hidden='true' /></a>}
                    </div>
                    <div className='blog-col-center'>
                        {props.ArticleList && props.ArticleList.length > 0 &&
                            props.ArticleList.map((article, index) =>
                                <div key={index} itemScope itemType='https://schema.org/BlogPosting' className='blog-list-item'>
                                    {article.Thumbnail > 0 &&
                                        <div className='blog-list-item-image-wrapper'>
                                            <div className='blog-list-item-image'>
                                                <a href={article.Url}>
                                                    <img itemProp='image' alt={article.PageHeader} src={article.ImageUrl} />
                                                </a>
                                            </div>
                                        </div>
                                    }
                                    <div className={(article.Thumbnail > 0 ? 'column9' : 'column12') + ' left'}>
                                        <div className='blog-list-item-title'>
                                            <span itemProp='datePublished' content={article.DisplayLastUpdate ? article.UpdatedDateFormatted : article.PostedDateFormatted}></span>
                                            <ConditionalWrapper condition={props.UseSEOHTagReorganization} wrapper={children => <h3 className="header-reset">{children}</h3>}>
                                                <a itemProp='url' href={article.Url}><span itemProp='headline'>{article.PageHeader}</span></a>
                                            </ConditionalWrapper>
                                        </div>
                                        <div class="blog-credits blog-credits-list">
                                            {article.AuthorBylineFormatted && <div dangerouslySetInnerHTML={{ __html: article.AuthorBylineFormatted }} />}
                                            <div dangerouslySetInnerHTML={{ __html: article.DisplayLastUpdate ? article.UpdatedOnDateFormatted : article.PostedOnDateFormatted }} />
                                        </div>
                                        <div itemProp='description' className='blog-list-item-body'>
                                            {article.SummaryPlainText}
                                        </div>
                                        <div className='blog-list-item-read-more'>
                                            <a href={article.Url}><TranslationText tKey='sandhills.tradepubwebsite.mvc.readthefullblogpost' /></a>
                                        </div>
                                    </div>
                                </div>)}
                        {props.Paging.TotalPages > 1 &&
                            <div className='row paging article-paging'>
                                <Paging
                                    currentPage={props.Paging.CurrentPage}
                                    totalPages={props.Paging.TotalPages}
                                    onChange={pageChange}
                                />
                            </div>}
                    </div>
                    <div className='blog-col-right columns'>
                        <BlogArticleCategories Categories={props.Categories} UseSEOHTagReorganization={props.UseSEOHTagReorganization} />
                        {props.Tags && props.Tags.length > 0 && <BlogArticleTags Tags={props.Tags} />}
                        {props.DisplayArchiveList && <BlogArticleArchiveMenu ArchiveArticleList={props.ArchiveArticleList} />}
                    </div>

                    {showEmailModal &&
                        <EmailModal
                            {...samModel}
                            toggleEmailModal={onEmailModalToggle}
                            selectedInquiry={selectedInquiry}
                            ShowSocialShareButtons={showShareButtons}
                        />}
                </div>
            </div>
        </div>
    );
};

export default BlogListView;
global.BlogListView = BlogListView;